module.exports = __webpack_public_path__ + "img/avatar-default.e6021087.png";